import { CustomModal, NakedTable, FormEntry } from "components";
import { useReducer, useCallback, useEffect } from "react";
import { FormGroup } from "./NewEventModal";
import { Button } from "reactstrap";
import { Controller, useWatch } from "react-hook-form";
import Select from "react-select";
import { useQuery } from "react-query";
import apiService from "services/api";
import { tConv24 } from "utils/dateHelper";

const initialModalState = {
	show: false,
	data: null,
};

const modalAction = {
	open: "OPEN",
	close: "CLOSE",
};

const modalReducer = (state, action) => {
	switch (action.type) {
		case modalAction.open:
			return { ...state, show: true, data: action.payload };
		case modalAction.close:
			return initialModalState;
		default:
			throw new Error("Invalid action");
	}
};

const teacherTableColumns = ({ date, startTime, endTime }) => [
	{
		header: `Available Teachers at ${date} on ${tConv24(startTime)} - ${tConv24(endTime)}`,
		accessor: (row) => <div>{row?.fullName}</div>,
	},
];

export const sortLessonRecords = (arr) => {
	return arr.sort((r1, r2) => (r1.date > r2.date ? -1 : r1.date < r2.date ? 1 : 0));
};

const useSelectTeacherModal = () => {
	const [modalState, modalDispatch] = useReducer(modalReducer, initialModalState);

	const Component = useCallback(
		({ errors, control, availableTeachers, date, startTime, endTime, teacherOptions }) => {
			return (
				<CustomModal
					show={modalState.show}
					title="Select Teacher"
					hideModal={() => modalDispatch({ type: modalAction.close })}
					light={true}
					triggerAlertMessageWhenClose="Are you sure you want to close? Form entries will be reset."
					buttons={
						<div className="d-flex justify-between">
							<button
								className="btn btn-info"
								onClick={() => {
									modalDispatch({ type: "CLOSE" });
								}}
							>
								Done
							</button>
						</div>
					}
					zIndex={100}
					compact={true}
				>
					<div className="row">
						<div className="col">
							<FormGroup error={errors.teacher} formLabel="Teacher">
								<Controller
									control={control}
									name="teacher"
									render={({ field: { onChange, value, ref } }) => (
										<Select
											inputRef={ref}
											className="react-select info"
											classNamePrefix="react-select"
											key={value}
											value={teacherOptions?.find((c) => c.value?.id === value?.id)}
											onChange={(val) => onChange(val.value)}
											placeholder="Select teacher...."
											options={teacherOptions || []}
										/>
									)}
								/>
							</FormGroup>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<NakedTable data={availableTeachers} columns={teacherTableColumns({ date, startTime, endTime })} maxHeight={400} />
						</div>
					</div>
				</CustomModal>
			);
		},
		[modalState.show]
	);
	return [Component, modalState, modalDispatch];
};

export default useSelectTeacherModal;
